import {
    StyledListingCardLandscapeBody,
    StyledSavedListingInfo,
    StyledListingCardLandscape
} from './ListingCardLandscape.styles';
import { SavedListingCardFooter, FooterSection } from './Footer/Footer.styles';
import {
    Skeleton,
    SkeletonBlock,
    SkeletonRow,
    SkeletonItem
} from '../Skeleton/Skeleton.styles';
import { ListingImage } from '@zoopla/listings/image';

export const ListingCardLandscapeSkeleton = () => {
    return (
        <Skeleton aria-hidden>
            <StyledListingCardLandscape data-testid="listing-card-skeleton">
                <StyledListingCardLandscapeBody>
                    <ListingImage useImagePlaceholder={false} />
                    <StyledSavedListingInfo>
                        <SkeletonBlock>
                            <SkeletonRow>
                                <SkeletonItem size={24} />
                            </SkeletonRow>
                            <SkeletonRow>
                                <SkeletonItem size={18} />
                            </SkeletonRow>
                            <SkeletonRow>
                                <SkeletonItem size={28} />
                            </SkeletonRow>
                            <SkeletonRow spacing={2}>
                                <SkeletonItem size={5} />
                                <SkeletonItem size={5} />
                                <SkeletonItem size={5} />
                            </SkeletonRow>
                        </SkeletonBlock>
                    </StyledSavedListingInfo>
                </StyledListingCardLandscapeBody>
                <SavedListingCardFooter>
                    <FooterSection>
                        <SkeletonBlock>
                            <SkeletonRow>
                                <SkeletonItem size={30} />
                            </SkeletonRow>
                        </SkeletonBlock>
                    </FooterSection>
                    <FooterSection>
                        <SkeletonBlock>
                            <SkeletonRow spacing={4}>
                                <SkeletonItem size={12} />
                                <SkeletonItem size={12} />
                                <SkeletonItem size={12} />
                            </SkeletonRow>
                        </SkeletonBlock>
                    </FooterSection>
                </SavedListingCardFooter>
            </StyledListingCardLandscape>
        </Skeleton>
    );
};
